import Keycloak from "keycloak-js";
import { authItemsPaths } from "../routes/paths";

const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_JSON_URL,
  redirectUri: process.env.REACT_APP_KEYCLOAK_REDIRECT_URL,
};

const _kc = new Keycloak(keycloakConfig.url);

const storeTokens = () => {
  if (_kc.token) localStorage.setItem("token", _kc.token);
  if (_kc.refreshToken) localStorage.setItem("refresh-token", _kc.refreshToken);
};

const clearlocal = () => {
  ["token", "refresh-token"].forEach((item) => localStorage.removeItem(item));
  localStorage.clear();
};

/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */

const initKeycloak = async (onAuthenticatedCallback) => {
  try {
    const authenticated = await _kc.init({
      onLoad:
        authItemsPaths.filter((path) =>
          path.path.includes(window.location.pathname)
        ) && window.location.pathname !== "/"
          ? "check-sso"
          : "login-required",
      checkLoginIframe: false,
    });

    if (!authenticated) {
      console.log("User is not authenticated.");
      onAuthenticatedCallback();
      //   return;
    } else {
      storeTokens();
      _kc.redirectUri = keycloakConfig.redirectUri;
      onAuthenticatedCallback();

      _kc.onTokenExpired = handleTokenExpiry;
    }
  } catch (error) {
    console.error("Keycloak initialization error:", error);
  }
};

const handleTokenExpiry = () => {
  _kc.updateToken(30).then(storeTokens).catch(clearlocal);
};

const updateToken = async () => {
  try {
    const refreshed = await _kc.updateToken(-1);
    if (refreshed) storeTokens();
  } catch (error) {
    console.error("Failed to update token:", error);
  }
};

const UserService = {
  initKeycloak,
  doLogin: _kc.login.bind(_kc),
  doLogout: _kc.logout.bind(_kc),
  isLoggedIn: () => !!_kc.token,
  getToken: () => _kc.token,
  updateToken,
  getUsername: () => _kc.tokenParsed?.preferred_username,
  loadUserProfile: _kc.loadUserProfile.bind(_kc),
  hasRole: (roles) => roles.some((role) => _kc.hasRealmRole(role)),
};

export default UserService;
